import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgList = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 4,
					cy: 7,
					r: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 4,
					cy: 12,
					r: 1
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 4,
					cy: 17,
					r: 1
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 7,
					y: 11,
					width: 14,
					height: 2,
					rx: .94
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 7,
					y: 16,
					width: 14,
					height: 2,
					rx: .94
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 7,
					y: 6,
					width: 14,
					height: 2,
					rx: .94
				})
			]
		})
	})
});
export { SvgList as ReactComponent };
